import _defineProperty from "/home/program/front/git/ams/node_modules/_@babel_runtime-corejs2@7.28.3@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
/*
 * 全站共用字典 VERSION:V1.0.0
 * @author   : yaozijun
 * @datetime : 2020/1/14
 */

export var FILE_URL = "".concat(process.env.VUE_APP_FILE_DOMAIN, "/edufile");
export var FILE_URL_PREVIEW = "".concat(FILE_URL, "/keyPreview?uniqueKey="); //文件系统预览地址

export var FILE_URL_DOWNLOAD = "".concat(FILE_URL, "/download?uniqueKey="); //文件系统下载地址

export var DEFALUT_TITLE = '资产管理系统';
export var CONFIG_TITLE = {
  "ams.qbjjyyun.net": "成都青白江区资产管理系统",
  "ams.pjxedu.cn": "成都蒲江县资产管理系统",
  "ams.yzx.scjsdsj.com": "乐山市资产管理系统",
  "ams.live.educlouddata.com": "云海泛舟资产管理系统",
  "ams.cszxy.cn": "数字校园资产管理系统"
};

//资产状态
export var AMS_STATUS_IDLE = 43001; //闲置
export var AMS_STATUS_USING = 43002; //使用中
export var AMS_STATUS_CLAIMING = 43003; //申领中
export var AMS_STATUS_DISTRIBUTING = 43004; //派发中
export var AMS_STATUS_REPAIR = 43005; //维修中
export var AMS_STATUS_TRANSFERRING = 43006; //转移中
export var AMS_STATUS_ALLOCATE = 43007; //调拨中
export var AMS_STATUS_BORROWING = 43008; //借用中
export var AMS_STATUS_SCRAPPED = 43009; //已报废
export var AMS_STATUS_REPAIR_APPLY = 43010; //报修中

export var AMS_STATUS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AMS_STATUS_IDLE, "闲置"), AMS_STATUS_USING, "使用中"), AMS_STATUS_CLAIMING, "申领中"), AMS_STATUS_DISTRIBUTING, "派发中"), AMS_STATUS_REPAIR, "维修中"), AMS_STATUS_TRANSFERRING, "转移中"), AMS_STATUS_ALLOCATE, "调拨中"), AMS_STATUS_BORROWING, "借用中"), AMS_STATUS_SCRAPPED, "报废"), AMS_STATUS_REPAIR_APPLY, "报修中");
export var AMS_COLOR = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AMS_STATUS_IDLE, "#4CBF8A"), AMS_STATUS_USING, "#59BAFF"), AMS_STATUS_CLAIMING, "#ff9d68"), AMS_STATUS_DISTRIBUTING, "#98c859"), AMS_STATUS_REPAIR, "#FFC15F"), AMS_STATUS_TRANSFERRING, "#ca9cf2"), AMS_STATUS_ALLOCATE, "#5ec4d6"), AMS_STATUS_BORROWING, "#ea8bc1"), AMS_STATUS_SCRAPPED, "#FF6969"), AMS_STATUS_REPAIR_APPLY, "#40E0D0");

//新增资产可选状态
export var AMS_HAS_STATUS = [{
  id: AMS_STATUS_IDLE,
  label: AMS_STATUS["".concat(AMS_STATUS_IDLE)]
}, {
  id: AMS_STATUS_USING,
  label: AMS_STATUS["".concat(AMS_STATUS_USING)]
}, {
  id: AMS_STATUS_REPAIR,
  label: AMS_STATUS["".concat(AMS_STATUS_REPAIR)]
}, {
  id: AMS_STATUS_SCRAPPED,
  label: AMS_STATUS["".concat(AMS_STATUS_SCRAPPED)]
}, {
  id: AMS_STATUS_REPAIR_APPLY,
  label: AMS_STATUS["".concat(AMS_STATUS_REPAIR_APPLY)]
}];

//可以参与维修的状态
export var AMS_REPAIR_STATUS = [{
  id: AMS_STATUS_IDLE,
  label: AMS_STATUS["".concat(AMS_STATUS_IDLE)]
}, {
  id: AMS_STATUS_USING,
  label: AMS_STATUS["".concat(AMS_STATUS_USING)]
}];

//资产采购方式
export var AMS_BUY_WAY = {
  "1": "采购",
  "2": "租赁",
  "4": "调拨",
  "5": "接受捐赠",
  "6": "置换",
  "7": "盘盈",
  "3": "其他"
};
export var FILE_DOMAIN = process.env.VUE_APP_FILE_DOMAIN;
export var FILEA_DOMAIN = process.env.VUE_APP_FILEA_DOMAIN;
export var FILE_DOMAINS = {
  "filea": process.env.VUE_APP_FILEA_DOMAIN,
  "fileb": process.env.VUE_APP_FILEB_DOMAIN,
  "filec": process.env.VUE_APP_FILEC_DOMAIN,
  "filep": process.env.VUE_APP_FILEP_DOMAIN
};